import { Modal as AntdModal } from 'antd';
import classNames from 'classnames';
import classes from './Modal.module.css';

function Modal({ className, visible, open, ...rest }) {
  return <AntdModal centered className={classNames(classes.root, className)} open={open ?? visible} {...rest} />;
}

export default Modal;
